import getLicenseUrl from './getLicenseUrl'

const url = product => getLicenseUrl(product) + 'index.raw'

export default function fetchLicense(product) {
  return fetch(url(product))
    .then(res => res.text())
}
